/**
 * Resort Map JavaScript
 *
 * This file defines Resort Map
 * behavior.
 */

// load the google map
import './js/map';
// load the sidebar accordion functionality
import './js/tabs';
